// extracted by mini-css-extract-plugin
module.exports = {"root":"_43f7bc","selected":"_3b1168"};